import { makeStyles } from "components/providers/makeStyles";
import { useIsEmbedded } from "hooks/useIsEmbedded";

export const useStyles = makeStyles((theme, { isEmbedded }) => ({
    container: {
        paddingBottom: isEmbedded && theme.spacing(6),
        maxWidth: "100vw",
    },
}));

export const EventPageContainer = ({ children }) => {
    const isEmbedded = useIsEmbedded();
    const classes = useStyles({ isEmbedded });

    return <div className={classes.container}>{children}</div>;
};
